// src/components/UserSettings/UserSettings.js

import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tabs, Layout, Row, Col, Card } from 'antd';
import { UserOutlined, LockOutlined, TeamOutlined, LeftOutlined, AudioOutlined, BookOutlined } from '@ant-design/icons';
import Profile from './Profile/Profile';
import TwoFactorAuthentication from './EnableTwoFactorAuthentication/EnableTwoFactorAuthentication';
import TeamAccess from './TeamAccess/TeamAccess';
import Dictation from './Dictation/Dictation';
import Dictionary from './Dictionary/Dictionary';

const { Content } = Layout;
const { TabPane } = Tabs;

const UserSettings = () => {
  // Get the current tab from the URL parameters; default to 'profile'
  const { tab } = useParams();
  const navigate = useNavigate();
  const activeKey = tab || 'profile';

  // Define tabs using descriptive keys
  const tabs = [
    {
      label: (
        <>
          <UserOutlined /> Profile
        </>
      ),
      key: 'profile',
      children: <Profile />,
    },
    {
      label: (
        <>
          <LockOutlined /> Two Factor Authentication
        </>
      ),
      key: 'twofactor',
      children: <TwoFactorAuthentication />,
    },
    // {
    //   label: (
    //     <>
    //       <TeamOutlined /> Team Access
    //     </>
    //   ),
    //   key: 'teamaccess',
    //   children: <TeamAccess />,
    // },
    {
      label: (
        <>
          <AudioOutlined /> Dictation
        </>
      ),
      key: 'dictation',
      children: <Dictation />,
    },
    {
      label: (
        <>
          <BookOutlined /> Dictionary
        </>
      ),
      key: 'dictionary',
      children: <Dictionary />,
    }
  ];

  // Update the URL when a tab is changed.
  const handleTabChange = (key) => {
    navigate(`/userSettings/${key}`);
  };

  return (
    <Content
      style={{
        padding: '20px',
        height: '80vh',
        boxSizing: 'border-box',
        overflow: 'auto',
      }}
    >
      <Row style={{ height: '100%', display: 'flex', padding: '10px' }}>
        <Col span={24} style={{ padding: '10px', display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Card
            style={{
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
            bodyStyle={{ flex: 1, overflow: 'auto' }}
          >
            <Link
              to="/synopsis"
              style={{
                fontSize: '20px',
                fontWeight: 600,
                paddingLeft: '20px',
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
              }}
            >
              <LeftOutlined style={{ marginRight: '8px' }} />
              Back to Interview
            </Link>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
              <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                tabPosition="left"
                style={{ flex: 1, overflow: 'auto' }}
                destroyInactiveTabPane={true}
              >
                {tabs.map((tab) => (
                  <TabPane tab={tab.label} key={tab.key}>
                    {tab.children}
                  </TabPane>
                ))}
              </Tabs>
            </div>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default UserSettings;
